/**
 * LIS API Endpoints
 * Centralized endpoint definitions for LIS operations.
 */
export const LIS_ENDPOINTS = {
  /**
   * Get visit by sample barcode
   * @method GET
   * @endpoint /lis/samples/{sampleBarcode}/visit
   * @param {string} sampleBarcode - Sample barcode
   */
  SAMPLE_VISIT: (sampleBarcode: string) => `/lis/samples/${encodeURIComponent(sampleBarcode)}/visit`,

  /**
   * Get patient test history
   * @method GET
   * @endpoint /lis/samples/{sampleBarcode}/patient/history/{testId}
   * @param {string} sampleBarcode - Sample barcode
   * @param {string} testId - Test ID
   */
  PATIENT_HISTORY: (sampleBarcode: string, testId: string) =>
    `/lis/samples/${encodeURIComponent(sampleBarcode)}/patient/history/${encodeURIComponent(testId)}`,

  /**
   * Calculate flagging for tests
   * @method POST
   * @endpoint /lis/flagging
   */
  FLAGGING: "/lis/flagging",
} as const;
